import React from 'react';
import { createStore } from 'zustand/vanilla';

var identity = function identity(arg) {
  return arg;
};

function useStore(api) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  var slice = React.useSyncExternalStore(api.subscribe, function () {
    return selector(api.getState());
  }, function () {
    return selector(api.getInitialState());
  });
  React.useDebugValue(slice);
  return slice;
}

var createImpl = function createImpl(createState) {
  var api = createStore(createState);

  var useBoundStore = function useBoundStore(selector) {
    return useStore(api, selector);
  };

  Object.assign(useBoundStore, api);
  return useBoundStore;
};

var create = function create(createState) {
  return createState ? createImpl(createState) : createImpl;
};

export { create, useStore };